import { Injectable } from '@angular/core'
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http'
import { Observable, throwError } from 'rxjs'
import { catchError, retry } from 'rxjs/operators'
import { AlertService } from '../services/alert-service'
import { Router, ActivatedRoute } from '@angular/router'
import { STORAGE_TOKEN } from '../../app-settings'

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(
    private alert: AlertService,
    private router: Router,
    private route: ActivatedRoute,
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const idToken = localStorage.getItem(STORAGE_TOKEN)
    const Token = idToken == null ? '' : idToken.split(',')[0]
    var cloned: any

    if (request.headers.get('skip')) {
      cloned = request.clone({
        setHeaders: {
          Accept: 'application/json',
          AGID: Token,
        },
      })
    } else {
      cloned = request.clone({
        setHeaders: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          AGID: Token,
        },
      })
    }

    return next.handle(cloned).pipe(
      catchError((response: HttpErrorResponse) => {
        if (response.status === 401) {
          localStorage.removeItem(STORAGE_TOKEN)
          this.router.navigate(['/login'])
        }
        if (response.status === 403 && !request.headers.get('skipForbidden')) {
          localStorage.removeItem(STORAGE_TOKEN)
          this.router.navigate(['/login'])
        }

        return throwError(response)
      }),
    )
  }
}
